<div class="tiime-form-header" [ngClass]="{ disabled: tiimeFormExpandedDisabled }" (click)="expandForm()">
  <ng-content select="[tiimeFormTitle]"></ng-content>
  @if (!tiimeFormExpandedDisabled) {
    <mat-icon
      class="tiime-form-toggle"
      inline="true"
      fontSet="fontastic"
      fontIcon="icon-arrow-bottom-12"
      [attr.aria-expanded]="tiimeFormExpanded"
    ></mat-icon>
  }
</div>
<div class="tiime-form-content" [attr.aria-expanded]="tiimeFormExpanded">
  <ng-content></ng-content>
</div>
